import React, { Fragment, useEffect, useRef, useState } from "react";
import { useAuth } from "../context/AuthContext";
import Table from "react-bootstrap/Table";
import { PaginationControl } from "react-bootstrap-pagination-control";
import { useLocation } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import DropDownTrustSelection from "../components/DropDownTrustSelection";
import DropDownFacilitySelection from "../components/DropDownFacilitySelection";
import DropDownRoleSelection from "../components/DropDownRoleSelection";
import UserSelection from "../components/UserSelection";
import {
  AxisDateTimeFull,
  AxisDateWithDay,
  AxisTime,
} from "../util/AxisDateTime";
import AxisSpinner from "../components/AxisSpinner";
import { ShiftTypeString } from "../util/ShiftOptionsSelection";
import { BsCalendarWeekFill } from "react-icons/bs";
import {
  ButtonBulkDelete,
  ButtonNewShift,
} from "../components/ShiftShiftButtonActionsElements";
import { Container } from "react-bootstrap";
import DateRangeSelectModal from "../modals/DateRangeSelectModal";
import ShiftCreateUpdateModal from "../modals/ShiftCreateUpdateModal";
import BulkDeleteModal from "../modals/BulkDeleteModal";
import DropDownFetchCount from "../components/DropDownFetchCount";
import moment from "moment";
import { ShiftLink, UserLink } from "../util/Links";
import XLSX from "xlsx";
import { PageTitleController } from "../components/PageTitleController";
import { ShiftTableDetailModal } from "../modals/ShiftTableDetailModal";
import { addDays } from "date-fns";
import { StatusIssueBadge } from "../components/BadgeNotificationCollection";

const ShiftsTable = () => {
  const historyKey = "ShiftsTable";
  let { state } = useLocation();
  if (state?.hasOwnProperty("redirectKey")) {
    localStorage.removeItem("history");
  }
  const getKeyStartingState = () => {
    if (state === null || state === undefined) return "shifts";
    if (state.hasOwnProperty("redirectKey")) return state.redirectKey;
    return "shifts";
  };

  let history = localStorage.key("history")
    ? JSON.parse(localStorage.getItem("history"))
    : null;
  if (history !== null && historyKey in history)
    history = JSON.parse(history[historyKey]);
  else {
    history = null;
  }

  if (
    history !== null &&
    history?.lastUpdated !== undefined &&
    new Date() - new Date(history.lastUpdated) > 600000
  ) {
    localStorage.removeItem("history");
    history = null;
  }

  const { authAxios } = useAuth();
  const [loading, setLoading] = useState(true);
  const [dataSource, setDataSource] = useState([]);
  const [offset, setOffset] = useState(history ? history?.offset : 0);
  const [totalShifts, setTotalShifts] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [fetchCount, setFetchCount] = useState(
    history ? history?.fetchCount : 25,
  );
  const [key, setKey] = useState(
    history ? history?.key : getKeyStartingState(),
  );
  const [trust, setTrust] = useState(history ? history?.trust : null);
  const [facility, setFacility] = useState(history ? history?.facility : null);
  const [role, setRole] = useState(history ? history?.role : null);
  const [sortKey, setSortKey] = useState(
    history ? history?.sortKey : "creationTime",
  );
  const [sortDirection, setSortDirection] = useState(
    history ? history?.sortDirection : "dsc",
  );
  const [showShiftCreate, setShowShiftCreate] = useState(false);
  const [showBulkDelete, setShowBulkDelete] = useState(false);
  const [showDateSelect, setShowDateSelect] = useState(false);
  const [rangeString, setRangeString] = useState("");
  const [range, setRange] = useState(
    history !== null && history?.range[0]?.startDate !== null
      ? [
          {
            startDate: new Date(history?.range[0]?.startDate),
            endDate: new Date(history?.range[0]?.endDate),
            key: history?.range?.key,
          },
        ]
      : [
          {
            startDate: null,
            endDate: null,
            key: "selection",
          },
        ],
  );
  const [user, setUser] = useState(history ? history?.user : null);
  const [detailModalVisible, setDetailModalVisible] = useState(false);
  const [selectDetail, setSelectDetail] = useState(null);
  const [disableClear, setDisableClear] = useState(false);
  const [searchValue, setSearchValue] = useState(
    history ? history?.searchValue : null,
  );
  const searchRef = useRef();
  const tableRef = useRef();
  const trustRef = useRef();
  const facilityRef = useRef();
  const roleRef = useRef();
  const userRef = useRef();
  const fetchCountRef = useRef();

  const clearFilters = () => {
    // Reset state
    setTrust(null);
    setFacility(null);
    setRole(null);
    setSortKey("creationTime");
    setSortDirection("dsc");
    setUser(null);
    setRange([
      {
        startDate: null,
        endDate: null,
        key: "selection",
      },
    ]);
    setRangeString("");
    searchRef.current.value = null;
    setSearchValue(null);
    
    // Reset UI components using refs
    if (trustRef.current) trustRef.current.reset();
    if (facilityRef.current) facilityRef.current.reset();
    if (roleRef.current) roleRef.current.reset();
    if (userRef.current) userRef.current.reset();
    if (fetchCountRef.current) fetchCountRef.current.reset();
  };

  const UpdateHistory = () => {
    if (
      range[0].startDate !== null &&
      moment(range[0].startDate).isBefore(moment("2000-01-01"))
    ) {
      setRange([
        {
          startDate: null,
          endDate: null,
          key: "selection",
        },
      ]);
      return;
    }

    var dateStr = "";
    if (range[0].startDate !== null) {
      dateStr = moment(range[0].startDate).format("YYYY-MM-DD");
    }
    if (range[0].endDate !== null) {
      dateStr += " -> ";
      dateStr += moment(range[0].endDate).format("YYYY-MM-DD");
    }
    setRangeString(dateStr);
    var saveStates = {};
    saveStates[historyKey] = JSON.stringify({
      key: key,
      trust: trust,
      role: role,
      range: range,
      sortKey: sortKey,
      sortDirection: sortDirection,
      facility: facility,
      offset: offset,
      user: user,
      lastUpdated: new Date(),
      fetchCount: fetchCount,
      searchValue: searchRef.current.value,
    });
    localStorage.setItem("history", JSON.stringify(saveStates));
  };

  useEffect(() => {
    document.title = "Shifts";
  }, []);

  useEffect(() => {
    setOffset(0);
    setTotalShifts(0);
    setTotalPages(1);
    paginateShifts();
    UpdateHistory();
  }, [key]);

  useEffect(() => {
    paginateShifts();
    UpdateHistory();
  }, [
    trust,
    role,
    range,
    facility,
    offset,
    fetchCount,
    sortKey,
    sortDirection,
    user,
    searchValue,
  ]);

  const closeDetailModal = () => {
    setDetailModalVisible(false);
    setSelectDetail(null);
  };

  const openDetailModal = (shift) => {
    setSelectDetail(shift);
    setDetailModalVisible(true);
  };

  const paginateShifts = async () => {
    try {
      setLoading(true);

      var params = {};
      if (key !== "shifts") {
        params["status"] = key;
      }
      if (trust !== null) {
        params["trust_id"] = trust?.id;
      }
      if (facility !== null) {
        params["facility_id"] = facility?.id;
      }
      if (role !== null) {
        params["role"] = role;
      }
      if (user !== null) {
        params["user_id"] = user?.id;
      }
      if (searchRef.current.value !== null && searchRef.current.value !== "") {
        params["search"] = searchRef.current.value;
      }
      if (
        range[0].endDate !== null &&
        range[0].endDate !== undefined &&
        range[0].startDate !== null &&
        range[0].startDate !== undefined
      ) {
        var st = range[0].startDate;
        var et = range[0].endDate;
        if (st.getTime() === et.getTime()) {
          et = addDays(et, 1);
        }
        params["startDate"] = moment(st).format("YYYY-MM-DD");
        params["endDate"] = moment(et).format("YYYY-MM-DD");
      }

      const pageSettings = {
        direction: sortDirection,
        key: sortKey,
        page: offset,
        elementPerPage: fetchCount,
      };
      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: params,
      };

      const page = await authAxios().post(
        "/api/backoffice/shifts/paging",
        pageSettings,
        config,
      );
      setLoading(false);

      if (page.data.content.length === 0) {
        if (dataSource.length === 0) {
          setTotalShifts(0);
        }
        console.log("empty api call");
        setDataSource([]);
        setTotalShifts(0);
        return;
      }

      var content = page.data.content.map((shift) => {
        shift["selected"] = false;
        return shift;
      });

      setDataSource(content);
      setTotalShifts(page.data.totalElements);
      var length = Math.ceil(page.data.totalElements / fetchCount);
      setTotalPages(length);
    } catch (error) {
      setLoading(false);
      console.log("Error catch");
      console.log(error);
      console.log(error.stack);
      setDataSource([]);
      setTotalShifts(0);
    }
    setDisableClear(false);
  };

  const exportTable = async () => {
    const wb = XLSX.utils.table_to_book(tableRef.current);
    XLSX.writeFile(wb, "ShiftsTable.xlsx");
  };

  const handleSetSortKey = (key) => {
    if (sortKey === key) {
      if (sortDirection === "asc") {
        setSortDirection("dsc");
      } else {
        setSortDirection("asc");
      }
      return;
    }
    setSortKey(key);
  };

  const tableHeading = (key, name) => {
    if (key === sortKey) {
      return sortDirection === "dsc" ? name + " ↓" : name + " ↑";
    }
    return name;
  };

  const isActiveTable = (key) => {
    return key === "OPEN";
  };

  const Checkbox = ({ isChecked, checkHandler, index }) => {
    return (
      <div>
        <input
          type="checkbox"
          id={`checkbox-${index}`}
          checked={isChecked}
          onChange={checkHandler}
        />
      </div>
    );
  };

  const toggleSelected = (index) => {
    setDataSource(
      dataSource.map((shift, currentIndex) =>
        currentIndex === index
          ? { ...shift, selected: !shift.selected }
          : shift,
      ),
    );
  };

  const getRowStyle = (user) => {
    var style = { cursor: "pointer" };
    var userMissing = user?.id === null;
    var shiftConfirmedOrIssue = key === "CONFIRMED" || key === "UNKNOWN";
    if (userMissing && shiftConfirmedOrIssue)
      style = {
        cursor: "pointer",
        backgroundColor: "rgba(255,0,0,0.8",
        border: "2px solid red",
      };

    return style;
  };

  const SpinnerOrData = (loading) => {
    if (loading) return <AxisSpinner loading={loading} />;
    return (
      <Fragment>
        <div style={{ opacity: loading ? 0.5 : 1 }}>
          <Table striped bordered hover ref={tableRef}>
            <thead>
              <tr style={{ cursor: "pointer" }}>
                {isActiveTable(key) ? <th></th> : null}

                <th onClick={() => handleSetSortKey("requestId")}>
                  {tableHeading("requestId", "Reference")}
                </th>
                {key === "PENDING" ||
                key === "PENDING_APPROVAL" ||
                key === "CONFIRMED" ||
                key === "COMPLETED" ? (
                  <th>Name</th>
                ) : null}
                <th onClick={() => handleSetSortKey("trust_id")}>
                  {tableHeading("trust_id", "Trust")}
                </th>
                <th onClick={() => handleSetSortKey("facility_id")}>
                  {tableHeading("facility_id", "Facility")}
                </th>
                <th onClick={() => handleSetSortKey("ward_id")}>
                  {tableHeading("ward_id", "Ward")}
                </th>
                <th onClick={() => handleSetSortKey("grade")}>
                  {tableHeading("grade", "Grade")}
                </th>
                <th onClick={() => handleSetSortKey("shiftType")}>
                  {tableHeading("shiftType", "Type")}
                </th>
                <th onClick={() => handleSetSortKey("status")}>
                  {tableHeading("status", "Status")}
                </th>
                <th onClick={() => handleSetSortKey("start")}>
                  {tableHeading("start", "Date")}
                </th>
                <th onClick={() => handleSetSortKey("start")}>
                  {tableHeading("start", "Start")}
                </th>
                <th onClick={() => handleSetSortKey("end")}>
                  {tableHeading("end", "End")}
                </th>
                <th onClick={() => handleSetSortKey("creationTime")}>
                  {tableHeading("creationTime", "Created")}
                </th>
              </tr>
            </thead>
            <tbody>
              {dataSource.map((shift, index) => (
                <tr key={shift?.id} style={getRowStyle(shift?.user)}>
                  {isActiveTable(key) ? (
                    <td
                      className={
                        shift?.availabilityMatches && shift?.status === "OPEN"
                          ? "axis-table-availability-match-right"
                          : ""
                      }
                    >
                      <Checkbox
                        key={shift?.id}
                        isChecked={shift?.selected}
                        checkHandler={() => toggleSelected(index)}
                        index={index}
                      />
                    </td>
                  ) : null}
                  <td
                    className={
                      shift?.availabilityMatches && shift?.status === "OPEN"
                        ? "axis-table-availability-match"
                        : ""
                    }
                  >
                    {ShiftLink(shift)}
                  </td>

                  {key === "PENDING" ||
                  key === "PENDING_APPROVAL" ||
                  key === "CONFIRMED" ||
                  key === "COMPLETED" ? (
                    <td>{UserLink(shift?.user)}</td>
                  ) : null}
                  <td onClick={() => openDetailModal(shift)}>
                    {shift?.trust?.shortName}
                  </td>
                  <td onClick={() => openDetailModal(shift)}>
                    {shift?.facility?.name}
                  </td>
                  <td onClick={() => openDetailModal(shift)}>
                    {shift?.ward?.identifier}
                  </td>
                  <td onClick={() => openDetailModal(shift)}>{shift?.grade}</td>
                  <td onClick={() => openDetailModal(shift)}>
                    {ShiftTypeString(shift?.shiftType)}
                  </td>
                  <td
                    className={"text-capitalize"}
                    onClick={() => openDetailModal(shift)}
                  >
                    {shift?.status.replace(/_/g, " ").toLowerCase()}
                  </td>
                  <td onClick={() => openDetailModal(shift)}>
                    {AxisDateWithDay(shift?.start)}
                  </td>
                  <td onClick={() => openDetailModal(shift)}>
                    {AxisTime(shift?.start)}
                  </td>
                  <td onClick={() => openDetailModal(shift)}>
                    {AxisTime(shift?.end)}
                  </td>
                  <td onClick={() => openDetailModal(shift)}>
                    {AxisDateTimeFull(shift?.creationTime)}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        <div>
          Page {offset + 1} of {totalPages}, showing {dataSource.length} record
          {dataSource.length === 1 ? "" : "s"} out of {totalShifts}
          <div>
            <PaginationControl
              page={offset + 1}
              between={3}
              total={totalShifts}
              limit={fetchCount}
              changePage={(page) => {
                setOffset(page - 1);
              }}
              ellipsis={1}
            />
          </div>
        </div>
      </Fragment>
    );
  };

  const show = () => {
    setShowShiftCreate(true);
  };

  return (
    <Fragment>
      <Row className={"icon-text-wrapper"}>
        <PageTitleController
          title={"Shifts"}
          icon={<BsCalendarWeekFill className={"icon-right-spacing"} />}
        />
        <Col>
          <Row xs={"auto"} className={"justify-content-lg-end"}>
            {isActiveTable(key) ? (
              <ButtonBulkDelete action={() => setShowBulkDelete(true)} />
            ) : null}
            <ButtonNewShift action={() => setShowShiftCreate(true)} />
          </Row>
        </Col>
      </Row>

      <Tabs
        id="shifts-table-tabs"
        activeKey={key}
        onSelect={(k) => {
          setOffset(0);
          setKey(k);
        }}
        className="mb-3 axis-tab-container"
      >
        <Tab eventKey="shifts" title="Shifts"></Tab>
        <Tab eventKey="OPEN" title="Open"></Tab>
        <Tab eventKey="PENDING" title={StatusIssueBadge("Pending")}></Tab>
        <Tab eventKey="PENDING_APPROVAL" title={StatusIssueBadge("Pending Approval")}></Tab>
        <Tab eventKey="CONFIRMED" title={StatusIssueBadge("Confirmed")}></Tab>
        <Tab eventKey="CANCELLED" title="Cancelled"></Tab>
        <Tab eventKey="COMPLETED" title="Completed"></Tab>
        <Tab eventKey="EXPIRED" title="Expired"></Tab>
        <Tab eventKey="UNKNOWN" title={StatusIssueBadge("Issues")}></Tab>
      </Tabs>
      <Container fluid className={"p-0 m-0"}>
        <Row xs={"auto"} className={"align-items-center g-3"}>
          <Col xs={"auto"}>
            <input
              className={"fs-input btn-w-px axis-input"}
              type="text"
              placeholder="Search Request ID"
              ref={searchRef}
              defaultValue={searchValue ? searchValue : null}
            />
          </Col>
          <Col>
            <input
              className={"fs-input btn-w-px axis-input"}
              type="text"
              placeholder="Date Range"
              value={rangeString}
              onClick={() => setShowDateSelect(true)}
            />
          </Col>
          <Col xs={"auto"}>
            <DropDownTrustSelection
              ref={trustRef}
              onSelected={setTrust}
              defaultValue={trust}
              placeholderText="Select Trust"
            />
          </Col>
          <Col xs={"auto"}>
            <DropDownFacilitySelection
              ref={facilityRef}
              trust={trust}
              onSelected={setFacility}
              defaultValue={facility}
              placeholderText="Select Facility"
            />
          </Col>
          <Col xs={"auto"}>
            <DropDownRoleSelection 
              ref={roleRef}
              onSelected={setRole} 
              defaultValue={role}
              placeholderText="Select Role"
            />
          </Col>

          <Col xs={"auto"}>
            <DropDownFetchCount
              ref={fetchCountRef}
              onSelected={setFetchCount}
              defaultSelection={fetchCount}
              placeholderText="Select Rows"
            />
          </Col>
          <Col xs={"auto"}>
            <UserSelection 
              ref={userRef}
              onSelected={setUser} 
              defaultValue={user}
              placeholderText="Select User"
            />
          </Col>
          <Col xs={"auto"}>
            <Button
              variant={"outline-offblack"}
              onClick={() => setSearchValue(searchRef.current.value)}
            >
              Filter
            </Button>
          </Col>
          <Col xs={"auto"}>
            <Button
              variant={"danger"}
              className={"clear-filters-btn"}
              onClick={() => {
                setDisableClear((prevState) => !prevState);
                clearFilters();
              }}
              disabled={disableClear}
            >
              <strong>Clear Filters</strong>
            </Button>
          </Col>
        </Row>
      </Container>

      <br />

      {SpinnerOrData(loading)}

      <BulkDeleteModal
        visible={showBulkDelete}
        close={() => {
          setShowBulkDelete(false);
          paginateShifts();
        }}
        shifts={dataSource}
      />
      <DateRangeSelectModal
        visible={showDateSelect}
        close={() => setShowDateSelect(false)}
        range={range}
        setRange={setRange}
      />
      <ShiftCreateUpdateModal
        visible={showShiftCreate}
        close={() => setShowShiftCreate(false)}
      />
      <ShiftTableDetailModal
        shift={selectDetail}
        close={closeDetailModal}
        visible={detailModalVisible}
      />
    </Fragment>
  );
};

export default ShiftsTable;
